import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const GeocercasTable = () => {
  const [geocercas, setGeocercas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [expandedRow, setExpandedRow] = useState(null);
  const [parsedCoords, setParsedCoords] = useState([]);
  const [showAddForm, setShowAddForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const { token, user } = useSelector(state => state.auth);  

  // Estado para el formulario de geocerca
  const [geocercaForm, setGeocercaForm] = useState({
    geo_tipo: 1,
    geo_nombre: '',
    geo_descripcion: '',
    geo_poligono: '',
    geo_codusr: user.id_usuario + '',
    geo_ruta: '',
    geo_subruta: '',
    tg_nombre:''
  });

  const fetchSolicitudes = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const requestData = {
        Token: 'LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY',
        Ambiente: 'DESA',
        Dispositivo: {
          Marca: 'SAMSUNG',
          Modelo: 'S22002B',
          Version: 'Android 18.125',
          McAdress: null,
          PowerStatus: '84%',
          WifiStatus: 'Conected to iphone de Mauricio',
          GPSStatus: 'ON',
          GPS: '321|-485|321'
        },
        Usr: {
          Codigo: '',
          UserNickName: 'pierril'
        },
        DatosMetodo: {
          NombreMetodo: 'ControlGeocercas',
          Datos_Recibidos: '{"Accion":"SEL"}'
        }
      };
    
      console.log(requestData);
      const url = `https://appcorp.parma.com.gt/API/ReceptorDatos?Datos=${encodeURIComponent(JSON.stringify(requestData))}`;
      const response = await fetch(url);

      if (!response.ok) {
        throw new Error(`Error HTTP: ${response.status}`);
      }
      
      const data = await response.json();
      
      if (!data.datos_Generados) {
        throw new Error('No se encontraron datos generados');
      }
      
      const datosGenerados = JSON.parse(data.datos_Generados);
      setGeocercas(datosGenerados.GEOCERCAS || []);
      
    } catch (err) {
      setError(err.message);
      console.error('Error al obtener geocercas:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitGeocerca = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const requestData = {
        Token: 'LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY',
        Ambiente: 'DESA',
        Dispositivo: {
          Marca: 'SAMSUNG',
          Modelo: 'S22002B',
          Version: 'Android 18.125',
          McAdress: null,
          PowerStatus: '84%',
          WifiStatus: 'Conected to iphone de Mauricio',
          GPSStatus: 'ON',
          GPS: '321|-485|321'
        },
        User: {
          Codigo: '',
          UserNickName: 'pierril'
        },
        Metodo: {
          NombreMetodo: 'ControlGeocercas',
          Datos_Recibidos: JSON.stringify({
            Accion: editingId ? "UPD" : "INS",
            geo_codigo: editingId || undefined,
            ...geocercaForm
          }), 
          Datos_Generados: '',

        }
      };
      console.log(requestData)
      const url = 'https://appcorp.parma.com.gt/API/ReceptorDatos';
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestData)
      });
      alert('exitoso')
      if (!response.ok) {
        throw new Error(`Error HTTP: ${response.status}`);
      }
      
      const data = await response.json();
      
      // Actualizar la lista después de la operación
      await fetchSolicitudes();
      
      // Cerrar el formulario y resetear los valores
      setShowAddForm(false);
      setEditingId(null);
      setGeocercaForm({
        geo_tipo: 1,
        geo_nombre: '',
        geo_descripcion: '',
        geo_poligono: '',
        geo_codusr: user.id_usuario + '',
        geo_ruta: '',
        geo_subruta: '',
        tg_nombre:''
      });
      
    } catch (err) {
      setError(err.message);
      console.error('Error al procesar geocerca:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (geocerca) => {
    setEditingId(geocerca.geo_codigo);
    setGeocercaForm({
      geo_tipo: geocerca.geo_tipo,
      geo_nombre: geocerca.geo_nombre,
      geo_descripcion: geocerca.geo_descripcion,
      geo_poligono: geocerca.geo_poligono,
      geo_codusr: user.id_usuario + '',
      geo_ruta: geocerca.geo_ruta,
      geo_subruta: geocerca.geo_subruta,
      tg_nombre: geocerca.tg_nombre
    });
    setShowAddForm(true);
  };

  const parseCoordinates = (polygonStr) => {
    if (!polygonStr) return [];
    
    return polygonStr.split(' ').map(coord => {
      const parts = coord.split(',');
      const longitude = parts[0] ? parseFloat(parts[0]).toFixed(6) : '0.000000';
      const latitude = parts[1] ? parseFloat(parts[1]).toFixed(6) : '0.000000';
      const altitude = parts[2] !== undefined ? parseFloat(parts[2]).toFixed(2) : '0';
      
      return { 
        latitude,
        longitude, 
        altitude
      };
    });
  };

  const toggleRowExpand = (index) => {
    if (expandedRow === index) {
      setExpandedRow(null);
    } else {
      setExpandedRow(index);
      const coords = parseCoordinates(geocercas[index].geo_poligono);
      setParsedCoords(coords);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setGeocercaForm(prev => ({
      ...prev,
      [name]: value
    }));
  };

  useEffect(() => {
    console.log(user); 
    fetchSolicitudes();
  }, []);

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <h1 style={{ color: '#333', marginBottom: '20px' }}>Geocercas</h1>
      
      <div style={{ marginBottom: '20px', display: 'flex', gap: '10px' }}>
        <button 
          onClick={fetchSolicitudes} 
          disabled={loading}
          style={{
            padding: '10px 15px',
            backgroundColor: '#4CAF50',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontWeight: 'bold'
          }}
        >
          {loading ? 'Cargando...' : 'Actualizar Datos'}
        </button>
        
        <button 
          onClick={() => {
            setEditingId(null);
            setShowAddForm(!showAddForm);
          }}
          disabled={loading}
          style={{
            padding: '10px 15px',
            backgroundColor: '#2196F3',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontWeight: 'bold'
          }}
        >
          {showAddForm ? 'Cancelar' : 'Agregar Geocerca'}
        </button>
      </div>
      
      {error && (
        <div style={{ 
          color: '#D8000C',
          backgroundColor: '#FFD2D2',
          padding: '10px',
          borderRadius: '4px',
          marginBottom: '20px',
          border: '1px solid #D8000C'
        }}>
          <strong>Error:</strong> {error}
        </div>
      )}
      
      {showAddForm && (
        <div style={{ 
          backgroundColor: '#f9f9f9', 
          padding: '20px', 
          borderRadius: '4px',
          marginBottom: '20px',
          border: '1px solid #ddd'
        }}>
          <h2 style={{ marginTop: '0' }}>{editingId ? 'Editar' : 'Agregar Nueva'} Geocerca</h2>
          
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
            <div>
              <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Nombre:</label>
              <input
                type="text"
                name="geo_nombre"
                value={geocercaForm.geo_nombre}
                onChange={handleInputChange}
                style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ddd' }}
              />
            </div>
            
            {/* <div>
              <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Tipo:</label>
              <select
                name="geo_tipo"
                value={geocercaForm.geo_tipo}
                onChange={handleInputChange}
                style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ddd' }}
              >
                <option value="1">Tipo 1</option>
               {/* <option value="1">Tipo 1</option>
                <option value="3">Tipo 3</option>}
              </select>
            </div> */}
            
            <div>
              <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Descripción:</label>
              <input
                type="text"
                name="geo_descripcion"
                value={geocercaForm.geo_descripcion}
                onChange={handleInputChange}
                style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ddd' }}
              />
            </div>
            
            {/* <div>
              <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Usuario:</label>
              <input
                type="text"
                name="geo_codusr"
                value={geocercaForm.geo_codusr}
                onChange={handleInputChange}
                style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ddd' }}
              />
            </div> */}
            
            <div>
              <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Ruta:</label>
              <input
                type="text"
                name="geo_ruta"
                value={geocercaForm.geo_ruta}
                onChange={handleInputChange}
                style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ddd' }}
              />
            </div>
            
            <div>
              <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Subruta:</label>
              <input
                type="text"
                name="geo_subruta"
                value={geocercaForm.geo_subruta}
                onChange={handleInputChange}
                style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ddd' }}
              />
            </div>
            
            <div style={{ gridColumn: '1 / -1' }}>
              <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Polígono (coordenadas separadas por espacios):</label>
              <textarea
                name="geo_poligono"
                value={geocercaForm.geo_poligono}
                onChange={handleInputChange}
                rows="5"
                style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ddd' }}
                placeholder="Ejemplo: -90.522988049915583,14.632260571259661,0 -90.518748426975449,14.63160939292308,0"
              />
            </div>
          </div>
          
          <button 
            onClick={handleSubmitGeocerca}
            disabled={loading}
            style={{
              padding: '10px 15px',
              backgroundColor: '#4CAF50',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              marginTop: '15px',
              fontWeight: 'bold'
            }}
          >
            {loading ? 'Enviando...' : (editingId ? 'Actualizar Geocerca' : 'Guardar Geocerca')}
          </button>
        </div>
      )}
      
      {loading && !showAddForm ? (
        <div style={{ textAlign: 'center', margin: '20px 0' }}>
          <p>Cargando datos...</p>
        </div>
      ) : (
        <div style={{ overflowX: 'auto' }}>
          <table style={{ 
             width: '200%', 
            //borderCollapse: 'collapse',
            boxShadow: '0 2px 3px rgba(0,0,0,0.1)'
          }}>
            <thead>
              <tr style={{ backgroundColor: '#f2f2f2' }}>
                <th colSpan="1" style={{ padding: '12px', textAlign: 'left', borderBottom: '1px solid #ddd' }}>Nombre</th>
                <th colSpan="2" style={{ padding: '12px', textAlign: 'left', borderBottom: '1px solid #ddd' }}>Descripción</th>
                <th colSpan="1" style={{ padding: '12px', textAlign: 'left', borderBottom: '1px solid #ddd' }}>Tipo</th>
                <th colSpan="2" style={{ padding: '12px', textAlign: 'left', borderBottom: '1px solid #ddd' }}>Usuario</th>
                <th colSpan="2" style={{ padding: '12px', textAlign: 'left', borderBottom: '1px solid #ddd' }}>Fecha</th>
                <th colSpan="2" style={{ padding: '12px', textAlign: 'left', borderBottom: '1px solid #ddd' }}>Ruta</th>
                <th colSpan="2" style={{ padding: '12px',  textAlign: 'left', borderBottom: '1px solid #ddd' }}>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {geocercas.map((geocerca, index) => (
                <React.Fragment key={index}>
                  <tr style={{ 
                    backgroundColor: expandedRow === index ? '#f9f9f9' : 'white',
                    borderBottom: '1px solid #ddd',
                    '&:hover': {
                      backgroundColor: '#f5f5f5'
                    }
                  }}>
                    <td colSpan="1" style={{ padding: '12px'}}>{geocerca.geo_nombre}</td>
                    <td colSpan="2" style={{ padding: '12px'}}>{geocerca.geo_descripcion}</td>
                    <td colSpan="1" style={{ padding: '12px'}}>{geocerca.tg_nombre}</td>
                    <td colSpan="2" style={{ padding: '12px'}}>{geocerca.UsrNombre} </td>
                    <td colSpan="2" style={{ padding: '12px'}}>{new Date(geocerca.geo_fecha).toLocaleString('es-ES', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  })}</td>
                    <td colSpan="2" style={{ padding: '12px'}}>{geocerca.geo_ruta || 'N/A'}</td>
                    <td colSpan="2" style={{ padding: '12px', display: 'flex', gap: '5px' }}>
                      <button 
                        onClick={() => toggleRowExpand(index)}
                        style={{
                          padding: '6px 12px',
                          backgroundColor: expandedRow === index ? '#ff9800' : '#2196F3',
                          color: 'white',
                          border: 'none',
                          borderRadius: '4px',
                          cursor: 'pointer'
                        }}
                      >
                        {expandedRow === index ? 'Ocultar' : 'Ver'}
                      </button>
                      <button 
                        onClick={() => handleEdit(geocerca)}
                        style={{
                          padding: '6px 12px',
                          backgroundColor: '#ffc107',
                          color: 'white',
                          border: 'none',
                          borderRadius: '4px',
                          cursor: 'pointer'
                        }}
                      >
                        Editar
                      </button>
                    </td>
                  </tr>
                  {expandedRow === index && (
                    <tr>
                      <td colSpan="4" style={{ padding: '20px', backgroundColor: '#f9f9f9' }}>
                        <div>
                          <h3 style={{ marginTop: '0' }}>Detalles de {geocerca.geo_nombre}</h3>
                          <div style={{ marginBottom: '15px' }}>
                            <strong>Coordenadas del polígono (Longitud, Latitud, Altura):</strong>
                            <div style={{ 
                              maxHeight: '200px', 
                              overflowY: 'auto',
                              marginTop: '10px',
                              border: '1px solid #ddd',
                              padding: '10px',
                              backgroundColor: 'white'
                            }}>
                              <table style={{ width: '50%', borderCollapse: 'collapse' }}>
                                <thead>
                                  <tr style={{ backgroundColor: '#eaeaea' }}>
                                    <th style={{ padding: '8px', textAlign: 'left' }}>#</th>
                                    <th style={{ padding: '8px', textAlign: 'left' }}>Longitud</th>
                                    <th style={{ padding: '8px', textAlign: 'left' }}>Latitud</th>
                                    <th style={{ padding: '8px', textAlign: 'left' }}>Altura</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {parsedCoords.map((coord, idx) => (
                                    <tr key={idx} style={{ borderBottom: '1px solid #eee' }}>
                                      <td style={{ padding: '8px' }}>{idx + 1}</td>
                                      <td style={{ padding: '8px' }}>{coord.longitude}</td>
                                      <td style={{ padding: '8px' }}>{coord.latitude}</td>
                                      <td style={{ padding: '8px' }}>{coord.altitude}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                          <div>
                            <strong>Polígono completo:</strong>
                            <pre style={{ 
                              whiteSpace: 'pre-wrap',
                              wordWrap: 'break-word',
                              backgroundColor: '#f0f0f0',
                              padding: '10px',
                              borderRadius: '4px',
                              marginTop: '10px'
                            }}>
                              {geocerca.geo_poligono}
                            </pre>
                          </div>
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </table>
          
          {geocercas.length === 0 && !loading && (
            <div style={{ 
              textAlign: 'center', 
              padding: '20px', 
              backgroundColor: '#f9f9f9',
              borderRadius: '4px',
              marginTop: '20px'
            }}>
              No se encontraron geocercas
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default GeocercasTable;